module.exports = __webpack_public_path__ + "img/switzerland-blood-diseases-female.ef63bb9b.png";